export default class Filters {
    constructor() {
        this.initFilters();
    }

    initFilters() {
        if (document.querySelector('#properties')) {
            const propertiesWrap = document.querySelector('#properties');
            const filterToggle = document.querySelector('#toggleFilter');
            const filterBox = document.querySelector('#filterBox');
            const closeFilter = document.querySelector('#closeFilter');

            if (filterToggle) {
                filterToggle.addEventListener('click', () => {
                    filterBox.classList.toggle('open');
                    propertiesWrap.classList.toggle('filter-open');
                });

                closeFilter.addEventListener('click', () => {
                    filterBox.classList.remove('open');
                    propertiesWrap.classList.remove('filter-open');
                });
            }

            const radioButtons = document.querySelectorAll('#filters input[type="radio"]');
            const selectKantoor = document.querySelector('#filters select[name="office"]');

            radioButtons.forEach((radio) => {
                radio.addEventListener('change', (e) => {
                    const { name, value } = e.target;
                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.set(name, value);
                    window.location.search = searchParams.toString();
                });
            });

            if (selectKantoor) {
                selectKantoor.addEventListener('change', (e) => {
                    const { name, value } = e.target;
                    const searchParams = new URLSearchParams(window.location.search);

                    if (value) {
                        searchParams.set(name, value);
                    } else {
                        searchParams.delete(name);
                    }

                    window.location.search = searchParams.toString();
                });
            }
        }
    }
}
